<template>
    <div>
		<b-form inline>
			<b-input-group v-if="!library && types.length > 0" prepend="Type">
				<b-select @change="change_type" v-model="type" :options="types"></b-select>
			</b-input-group>
		</b-form>

        <br />

        <b-tabs>
            <b-tab title="Document de départ">
                <div>
                    <br />
                    <b-button v-b-toggle="'collapse-doc'">Document</b-button><br /><br />

                    <b-collapse id="collapse-doc">
                        <documents
                            :select="true"
                            :download="false"
                            :select_view="false"
                            :ref="'doc'"
                            @add_file="set_document_ged"></documents>
                    </b-collapse>
                </div>
                <div :id="'original-' + id"></div>
            </b-tab>
            <b-tab title="Paramètres">

                <div v-show="params.length > 0">
                    <p>Paramètres</p>

                    <b-table :tbody-tr-class="(row, index) => ((!row.treatment && !library) || row.hidden) ? 'is-hidden' : ''" striped hover :items="params" :fields="fields">
                        <template v-slot:cell(value)="data">
                            <b-input :list="'my-list' + id" v-model="data.item.value" />
                            <datalist :id="'my-list' + id">
                                <option v-for="(option, idx) in keys" :key="idx">{{ option }}</option>
                            </datalist>
                        </template>
                        <template v-slot:cell(transform)="data">
                            <b-select v-model="data.item.transform" :options="[
                                {value: '', text: ''},
                                {value: 'lowercase', text: 'minuscule'},
                                {value: 'uppercase', text: 'MAJUSCULE'},
                                {value: 'capitalize', text: 'Nom Propre'},
                                {value: 'uppercase_first', text: '1ère lettre en majuscule'},
                            ]" />
                        </template>
                        <template v-slot:cell(treatment)="data">
                            <b-checkbox v-model="data.item.treatment" />
                        </template>
                    </b-table>
                </div>

                <div v-show="checkbox.length > 0">
                    <p>Paramètres des cases à cocher</p>

                    <b-table :tbody-tr-class="(row, index) => ((!row.treatment && !library) || row.hidden) ? 'is-hidden' : ''" striped hover :items="checkbox" :fields="checkbox_fields">
                        <template v-slot:cell(value)="data">
                            <b-input :list="'my-list_checkbox' + id" v-model="data.item.value" />
                            <datalist :id="'my-list_checkbox' + id">
                                <option v-for="(option, idx) in keys" :key="idx">{{ option }}</option>
                            </datalist>
                        </template>
                        <template v-slot:cell(true_value)="data">
                            <b-input v-model="data.item.true_value" />
                        </template>
                        <template v-slot:cell(idx)="data">
                            {{data.item.idx + 1}}
                        </template>
                        <template v-slot:cell(false_value)="data">
                            <b-input v-model="data.item.false_value" />
                        </template>
                        <template v-slot:cell(treatment)="data">
                            <b-checkbox v-model="data.item.treatment" />
                        </template>
                        <template v-slot:cell(default_value)="data">
                            <b-select v-model="data.item.default_value" :options="[
                                {value: null, text: ''},
                                {value: true, text: 'coché'},
                                {value: false, text: 'décoché'}
                            ]" />
                        </template>
                    </b-table>
                </div>

                <div>
                    
                    <p>Données de test et paramétrage</p>

                    <b-button v-if="library" @click="set_mapping(true)">Mapping automatique</b-button>&nbsp;&nbsp;
                    <b-button @click="set_mapping(false)">Récupérer la liste des colonnes</b-button>
                    <br /><br />

                    <b-select v-model="type_data_test" :options="[
                        {value: 'tabulator', text: 'Tableau'},
                        {value: 'database', text: 'Base de données'},
                        {value: 'DatabaseRequestView', text: 'Base de données - multitables'},
                    ]" />

                    <br /><br />

                    <div v-if="type_data_test == 'tabulator'">
                        <edit_tabulator ref="edit_tabulator"></edit_tabulator>
                    </div>

                    <DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
                        _type="db"
                        :minimal="true"
                        ref="edit_tabulator" />

                    <div v-if="type_data_test == 'database'">
                        <database
                            :change_table="true"
                            :name="false"
                            :edit="false"
                            ref="edit_tabulator"></database>
                    </div>
                </div>

            </b-tab>
            <b-tab title="Prévisualiser" @click="preview">
                <div :id="'preview-' + id"></div>

                <div v-if="false">
                    <p>Autre test</p>

                    <b-select v-model="other_type_data_test" :options="[
                        {value: 'tabulator', text: 'Tableau'},
                        {value: 'database', text: 'Base de données'},
                        {value: 'DatabaseRequestView', text: 'Base de données - multitables'},
                    ]" />

                    <br /><br />

                    <div v-if="other_type_data_test == 'tabulator'">
                        <edit_tabulator ref="other_edit_tabulator"></edit_tabulator>
                    </div>

                    <DatabaseRequestView v-if="other_type_data_test == 'DatabaseRequestView'"
                        _type="db"
                        :minimal="true"
                        ref="other_edit_tabulator" />

                    <div v-if="other_type_data_test == 'database'">
                        <database
                            :change_table="true"
                            :name="false"
                            :edit="false"
                            ref="other_edit_tabulator"></database>
                    </div>

                    <b-button @click="preview('test')">Tester</b-button>

                    <div :id="'other-preview-' + id"></div>
                </div>
            </b-tab>
        </b-tabs>
        <hr />
    </div>
</template>

<script>
    import { renderAsync, defaultOptions } from 'docx-preview';
    import uniqueId from "lodash.uniqueid";
    import VCalendar from 'v-calendar';
    import moment from "moment";
    import JSZip from 'jszip';
    import __ from 'lodash';
    
    require('moment/locale/fr')

	import store from "../store";
	import users from "../services/users.js";
    import library from "../services/library.js";
    import documents from "../views/Document.vue";
    import databaseView from "../views/database.vue";
    import treatments from "../services/treatments.js";
	import document_service from "../services/document.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
    import DatabaseRequestView from '../views/DatabaseRequestView.vue';
    
    var clone = require("clone");
    const _ = require("underscore");

	export default {
        name: "docx",
		components: {
            edit_tabulator,
            documents,
            DatabaseRequestView,
        	database: databaseView,
		},
		data() {
			return {
                id: uniqueId(""),
                
                docx: null,
                zip: null,
                data: "",
                arr: [],
                type_data_test: "tabulator",

                other_type_data_test: "tabulator",
                keys: [],

                params: [],
                checkbox: [],
                doc_ged: null,
                type: "",
                types: [],
                fields: [
                    {
                        key: 'name',
                        label: 'Nom',
                    },
                    {
                        key: 'value',
                        label: 'Valeur'
                    },
                    {
                        key: 'transform',
                        label: 'Transformation du texte'
                    }
                ],
                checkbox_fields: [
                    {
                        key: 'idx',
                        label: 'Position',
                    },
                    {
                        key: 'value',
                        label: 'Valeur'
                    },
                    {
                        key: 'true_value',
                        label: 'Coché si'
                    },
                    {
                        key: 'false_value',
                        label: 'Décoché si'
                    },
                    {
                        key: 'default_value',
                        label: 'Par default'
                    }
                ]
			};
		},
		props: {
			library: {
				default: false
			},
			type_doc: {
				default: ""
			}
		},
		computed: {
		},
		methods: {
			async set_document_ged(doc)
			{
				this.doc_ged = doc;

				doc = await document_service.getFile(doc.uid, doc.libelle, false, "blob", doc.share);
				await this.setDocument(doc);

				if (this.type_doc && this.doc_ged[this.type_doc])
				{
					if (this.types.includes(this.doc_ged[this.type_doc]))
					{
						this.type = this.doc_ged[this.type_doc];
						this.change_type(this.doc_ged[this.type_doc]);
					}
				}
			},
			async change_type(type)
			{
				console.log("change_type")
				var data = await library.getby_production("docx", type, true);
				this.load(data);
			},
			async load(data)
			{
                var self = this;

                this.doc_ged = data.doc;
                this.params = data.params;
                this.checkbox = data.checkbox || [];

                console.log(data)

                if (data.type_data_test)
                    this.type_data_test = data.type_data_test;

                self.$nextTick(async function () {

                    if (data.arr && self.type_data_test == "tabulator")
                    { 
                        await self.$refs.edit_tabulator.set_data(data.arr);
                    }

                    if (data.data_test)
                    { 
                        await self.$refs.edit_tabulator.load(data.data_test);
                    }

                    if (self.doc_ged)
                        self.set_document_ged(self.doc_ged);

                });
			},
			async save()
            {
                this.complete_params();

                var data_test = await this.$refs.edit_tabulator.save();

				return {
					params: this.params,
					checkbox: this.checkbox,
                    doc: this.doc_ged,
                    type_data_test: this.type_data_test, 
                    data_test
				}
			},
			get_data()
			{
				return {
					params: this.params,
					checkbox: this.checkbox,
					doc: this.doc_ged,
				}
            },
            set_mapping(mapping = false)
            {
                var data = this.$refs.edit_tabulator.get_data();
                if (!data || data.length == 0)
                    return;

                this.keys = Object.keys(data[0]);
                var keys = {};
                for (var i = 0; i < this.keys.length; i++)
                {
                    keys[this.keys[i].toLowerCase()] = this.keys[i];
                }

                if (mapping)
                {
                    for (var i = 0; i < this.params.length; i++)
                    {
                        if (!this.params[i].value && keys[this.params[i].name.toLowerCase()])
                            this.params[i].value = keys[this.params[i].name.toLowerCase()];
                    }      
                }
            },
            complete_params()
            {
                for (var i = 0; i < this.params.length; i++)
                {
                    if (this.params[i].hasOwnProperty("copy"))
                    {
                        this.params[i].value = this.params[this.params[i].copy].value;
                        this.params[i].transform = this.params[this.params[i].copy].transform || "";
                    }
                }
            },
            async preview(type = "") {
                var self = this;

                var ref_tabulator = "edit_tabulator";
                var ref_docx = 'preview-' + self.id; 
                if (type == "test")
                {
                    ref_tabulator = "other_edit_tabulator";
                    ref_docx = 'other-preview-' + self.id
                }
                
                var data = clone(this.data);
                this.arr = this.$refs[ref_tabulator].get_data();

                var i = -1;
                data = data.replace(/(<w14:checked w[^:]*:val=")(.*?)(".*?<w:t>)(.*?)(<\/w:t>)/g, function (match, p1, p2, p3, p4, p5) {
                    i++;
                    if (i < self.checkbox.length){
                        
                        var check = p2;
                        var char = ""

                        if (self.checkbox[i].default_value === true)
                            check = "1";
                        if (self.checkbox[i].default_value === false)
                            check = "0";

                        var value = self.checkbox[i].value;
                        if (self.arr.length > 0 && self.arr[0][value])
                            value = self.arr[0][value];
                        var compiled = __.template(value);
                        value = compiled({ data: self.arr.length > 0 ? self.arr[0]: {}, moment });

                        console.log(value)
                        console.log(value.match(self.checkbox[i].true_value))

                        if (self.checkbox[i].true_value && value.match(self.checkbox[i].true_value))
                            check = "1";
                        else if (self.checkbox[i].false_value && value.match(self.checkbox[i].false_value))
                            check = "0";
                        else
                        {
                            if (p4 == "☐" || p4 == "○")
                                check = "0";
                            if (p4 == "☒" || p4 == "🔘")
                                check = "1";
                        }

                        if (check == "0" && self.checkbox[i].format == "checkbox")
                            char = "☐";
                        if (check == "1" && self.checkbox[i].format == "checkbox")
                            char = "☒";
                        if (check == "0" && self.checkbox[i].format == "radio")
                            char = "○";
                        if (check == "1" && self.checkbox[i].format == "radio")
                            char = "🔘";

                        return p1 + check + p3 + char + p5;
                    } 
                    else {
                        return match;
                    };
                });

                this.complete_params();
                for (var i = 0; i < this.params.length; i++)
                {
                    var value = this.params[i].value;
                    var transform = this.params[i].transform || "";

                    if (this.arr.length > 0 && this.arr[0][value])
                        value = this.arr[0][value];

                    var compiled = __.template(value);
                    value = compiled({ data: this.arr.length > 0 ? this.arr[0]: {}, moment });

                    switch (transform)
                    {
                        case "lowercase":
                            value = value.toLowerCase()
                            break;
                        case "uppercase":
                            value = value.toUpperCase()
                            break;
                        case "uppercase_first":
                            value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
                            break;
                        case "capitalize":
                            value = value.toLowerCase().replace(/([A-Za-zÀ-ÖØ-öø-ÿ])([A-Za-zÀ-ÖØ-öø-ÿ]*)/g, (match, p1, p2) => p1.toUpperCase() + p2)
                            break;
                        default:
                            break;
                    }

                    data = data.replaceAll(this.params[i].key, value);
                }

                this.zip.file("word/document.xml", data);
                this.zip.generateAsync({type:"blob"})
                .then(function (blob) {
                    var element = document.getElementById(
                        ref_docx
                    );
                    renderAsync(blob, element).then(x => {});
                })
            }, 
            async setDocument (doc) {

                console.log("setDocument")

                console.log(doc);

				if (doc)
				{
                    if (!doc.name || doc.name.endsWith(".docx"))
                    {
					    var self = this;
                        self.docx = doc;

                        var element = document.getElementById(
                            'original-' + self.id
                        );
                        
                        renderAsync(self.docx, element).then(x => {});

                        self.zip = new JSZip();
                        self.zip.loadAsync(self.docx).then(function (zip) {
                            zip.file("word/document.xml").async("string").then(function (data) {

                                self.data = data;

                                var params = data.match(/{{.*?}}/g)
                                params = _.uniq(params);

                                console.log(params)

                                var old_params = clone(self.params)

                                self.params = [];
                                for (var i = 0; i < params.length; i++)
                                {
                                    var value = "";
                                    var transform = "";
                                    var treatment = false;
                                    for (var j = 0; j < old_params.length; j++)
                                    {
                                        if (params[i] == old_params[j].key)
                                        {
                                            value = old_params[j].value;
                                            transform = old_params[j].transform || "";
                                            treatment = old_params[j].treatment;
                                            break;
                                        }
                                    }

                                    self.params.push({
                                        key: params[i],
                                        name: params[i].replaceAll("{", "").replaceAll("}", "").replace(/<.*?>/g, "").trim(),
                                        type: "",
                                        value: value,
                                        transform: transform,
                                        treatment: treatment,
                                        hidden: false
                                    })
                                }

                                var params_obj = {};
                                for (var i = 0; i < self.params.length; i++)
                                {
                                    if (params_obj.hasOwnProperty(self.params[i].name))
                                    {
                                        self.params[i].hidden = true;
                                        self.params[i].copy = params_obj[self.params[i].name];
                                    }
                                    else
                                    {
                                        params_obj[self.params[i].name] = i
                                    }
                                }
                                /*self.params = _.uniq(self.params, false, function(x){
                                    return x.name;
                                });*/

                                var checkbox = []
                                var old_checkbox = clone(self.checkbox)
                                self.checkbox = [];
                                var search = /<w14:checked w[^:]*:val="(.*?)".*?<w:t>(.*?)<\/w:t>/g;
                                var matches = null;

                                while (matches = search.exec(data)) {
                                    checkbox.push(matches);
                                }
                                
                                for (var i = 0; i < checkbox.length; i++)
                                {
                                    /*var value = checkbox[i][1];
                                    if (checkbox[i][2] == "○" || checkbox[i][2] == "☐")
                                        value = "0";
                                    if (checkbox[i][2] == "🔘" || checkbox[i][2] == "☒")
                                        value = "1";*/
                                    var format = "checkbox";
                                    if (checkbox[i][2] == "○" || checkbox[i][2] == "🔘")
                                        format = "radio";
                                    var value = "";
                                    var true_value = "";
                                    var false_value = "";
                                    var treatment = false;
                                    var default_value = null;

                                    if (i < old_checkbox.length)
                                    {
                                        value = old_checkbox[i].value;
                                        format = old_checkbox[i].format;
                                        true_value = old_checkbox[i].true_value;
                                        false_value = old_checkbox[i].false_value;
                                        treatment = old_checkbox[i].treatment;
                                        default_value = old_checkbox[i].default_value;
                                    }

                                    self.checkbox.push({
                                        idx: i,
                                        value,
                                        format,
                                        true_value,
                                        false_value,
                                        treatment,
                                        default_value
                                    })
                                }

                                self.preview();
                            });
                        });
                    }
                    else
                    {
                        console.log(doc)
                        var results = await new Promise((resolve, reject) => {
                            this.$papa.parse(doc, {
                                header: true,
                                complete: function(results) {
                                    resolve(results)
                                }
                            });
                        });
                        console.log(results)
                        this.arr = [results.data[0]];
                        this.$refs.edit_tabulator.set_data(this.arr);

                        self.preview();
                    }
                }
			}
		},
		mounted: async function () {
            var self = this;

            var list = await library.getby_production("docx");
				
            for (var i = 0; i < list.element.length; i++)
            {
                this.types.push(list.element[i].name)
            }

            if (this.library)
            {
                this.fields.push(
                    {
                        key: 'treatment',
                        label: 'Paramètre de traitement'
                    }
                );
                this.checkbox_fields.push(
                    {
                        key: 'treatment',
                        label: 'Paramètre de traitement'
                    }
                );
            }            
		},
	};
</script>

<style>
.is-hidden {
    display: none;
}
</style>
